<div class="ced-shell" [class.ced-shell--expanded]="isExpanded">

  <!-- ===== ACCENT + HEADER ===== -->
  <div class="ced-accent" [style.background]="stage.color"></div>
  <div class="ced-header">
    <span class="ced-card-id">{{ card.id }}@if (isDirty) {<span class="ced-card-id-star" matTooltip="Alterações não salvas">*</span>}</span>
    <span class="ced-dot"></span>
    <span class="ced-stage-icon-lg" [style.background]="stage.tint" [style.border-color]="stage.color" [style.color]="stage.color">
      <mat-icon class="material-symbols-outlined">{{ stage.icon }}</mat-icon>
    </span>
    <div>
      <div class="ced-stage-name">{{ stage.name }}</div>
      <div class="ced-stage-step">{{ meta.stepLabel }}</div>
    </div>
    <!-- Modo NF: a nota aberta (ou a troca entre as NFs do pedido) e a troca entre os pedidos dela -->
    @if (notaModoNf; as nota) {
      <div class="ced-nf-head">
        <span class="ced-nf-head-rotulo">
          <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
          @if (notasPedido.length <= 1) {
            {{ nota.rotulo }}
          }
        </span>
        @if (notasPedido.length > 1) {
          <div class="ced-nf-switch" role="group" aria-label="Notas deste pedido">
            @for (n of notasPedido; track n.idNFeEntrada) {
              <button type="button" class="ced-nf-switch-btn" [class.ced-nf-switch-btn--atual]="n.idNFeEntrada === nota.idNFeEntrada"
                [attr.aria-pressed]="n.idNFeEntrada === nota.idNFeEntrada"
                [matTooltip]="n.idNFeEntrada === nota.idNFeEntrada ? 'Nota aberta' : 'Abrir pela ' + n.rotulo"
                (click)="trocarNotaPedido(n.idNFeEntrada)">{{ n.rotulo }}</button>
            }
          </div>
        }
        @if (pedidosNota.length > 1) {
          <div class="ced-nf-switch" role="group" aria-label="Pedidos desta nota">
            @for (p of pedidosNota; track p.idCompra) {
              <button type="button" class="ced-nf-switch-btn" [class.ced-nf-switch-btn--atual]="p.idCompra === card.idCompra"
                [attr.aria-pressed]="p.idCompra === card.idCompra"
                [matTooltip]="p.idCompra === card.idCompra ? 'Pedido aberto' : 'Abrir pedido ' + p.codigo"
                (click)="trocarPedidoNota(p.idCompra)">{{ p.codigo }}</button>
            }
          </div>
        }
      </div>
    }
    <span class="ced-head-spacer"></span>

    <!-- Em Finalizado só a observação de encerramento é editável (D-16); Cancelado e cotação arquivada não salvam. -->
    <div class="ced-split-btn" [class.ced-split-btn--inactive]="(!isDirty && !saving) || isSalvamentoBloqueado"
      [matTooltip]="motivoSalvarBloqueado" [matTooltipDisabled]="!motivoSalvarBloqueado">
      <button type="button" class="ced-split-main btn-spinner" [class.btn-loading]="saving"
        [disabled]="!isDirty || saving || isSalvamentoBloqueado" [attr.aria-label]="saving ? 'Salvando' : null" (click)="saveAndClose()"
        matTooltip="Salvar alterações e fechar" [matTooltipDisabled]="!!motivoSalvarBloqueado">
        <mat-icon class="material-symbols-outlined">save</mat-icon>
        <span>Salvar e fechar</span>
        @if (saving) { <mat-spinner diameter="18"></mat-spinner> }
      </button>
      <button type="button" class="ced-split-caret" [disabled]="!isDirty || saving || isSalvamentoBloqueado"
        [matMenuTriggerFor]="saveMenu" matTooltip="Mais opções" [matTooltipDisabled]="!!motivoSalvarBloqueado">
        <mat-icon class="material-symbols-outlined">arrow_drop_down</mat-icon>
      </button>
    </div>
    <mat-menu #saveMenu="matMenu">
      <button mat-menu-item (click)="save()">
        <mat-icon class="material-symbols-outlined">save</mat-icon>
        Salvar sem fechar
      </button>
    </mat-menu>

    <button
      mat-icon-button
      type="button"
      class="ced-head-icon"
      (click)="toggleExpanded()"
      [matTooltip]="isExpanded ? 'Recolher' : 'Expandir'">
      <mat-icon class="material-symbols-outlined">{{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
    <button mat-icon-button type="button" class="ced-head-icon" (click)="cancel()" matTooltip="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>

  <!-- ===== BODY (3 columns) ===== -->
  <div class="ced-body">
    <!-- Loader de página: cobre o corpo inteiro enquanto a nota (modo NF) ou a situação da etapa carregam. -->
    @if (carregandoEtapa() || (notaModoNf && carregandoNota())) {
      <div class="ced-body-loading" role="status" aria-live="polite" aria-label="Carregando">
        <mat-spinner diameter="44"></mat-spinner>
      </div>
    }

    <!-- ======= LEFT COLUMN ======= -->
    <div class="ced-col-left">

      <!-- Modo NF: dados da nota e pedidos vinculados (clicar troca o pedido aberto) -->
      @if (notaModoNf; as nota) {
        <div class="ced-nf">
          <div class="ced-nf-titulo">Nota fiscal</div>
          <!-- Pedido com 2+ NFs: troca de nota também aqui (o cabeçalho esconde as trocas em telas estreitas) -->
          @if (notasPedido.length > 1) {
            <div class="ced-nf-switch ced-nf-notas" role="group" aria-label="Notas deste pedido">
              @for (n of notasPedido; track n.idNFeEntrada) {
                <button type="button" class="ced-nf-switch-btn" [class.ced-nf-switch-btn--atual]="n.idNFeEntrada === nota.idNFeEntrada"
                  [attr.aria-pressed]="n.idNFeEntrada === nota.idNFeEntrada"
                  [matTooltip]="n.idNFeEntrada === nota.idNFeEntrada ? 'Nota aberta' : 'Abrir pela ' + n.rotulo"
                  (click)="trocarNotaPedido(n.idNFeEntrada)">{{ n.rotulo }}</button>
              }
            </div>
          }
          <!-- Nota em carga: o loader de página (ced-body-loading) cobre o corpo inteiro. -->
          @if (!carregandoNota()) {
            <!-- Falha ou nota ausente: os campos ficam vazios; o erro aparece na tabela "Itens da nota". -->
            @let nc = notaCarregada;
            <dl class="ced-nf-dados">
              <div class="ced-nf-dado">
                <dt>Emitente</dt>
                <dd>{{ nc?.nomeEmitente || '—' }}</dd>
              </div>
              <div class="ced-nf-dado ced-nf-dado--metade">
                <dt>Emissão</dt>
                <dd>{{ (nc?.nota?.dataEmissao | date: 'dd/MM/yyyy') || '—' }}</dd>
              </div>
              <div class="ced-nf-dado ced-nf-dado--metade">
                <dt>Valor total</dt>
                <dd class="ced-nf-dado-forte">{{ nc?.nota?.valorTotal != null ? (nc!.nota.valorTotal | abnt: 'preco' : 2) : '—' }}</dd>
              </div>
              <div class="ced-nf-dado">
                <dt>Chave de acesso</dt>
                <dd class="ced-nf-chave" [matTooltip]="nc?.nota?.chaveAcesso || ''">{{ nc?.nota?.chaveAcesso || '—' }}</dd>
              </div>
            </dl>
          }

          <div class="ced-nf-titulo">
            Pedidos nesta nota
            <span class="ced-chip-badge">{{ pedidosNota.length }}</span>
          </div>
          @for (p of pedidosNota; track p.idCompra) {
            <button type="button" class="ced-nf-pedido" [class.ced-nf-pedido--atual]="p.idCompra === card.idCompra"
              [attr.aria-current]="p.idCompra === card.idCompra ? 'true' : null"
              [matTooltip]="p.idCompra === card.idCompra ? '' : 'Abrir pedido ' + p.codigo"
              (click)="trocarPedidoNota(p.idCompra)">
              <span class="ced-nf-pedido-topo">
                <span class="ced-nf-pedido-codigo">{{ p.codigo }}</span>
                <span class="status-badge badge-cinza ced-nf-pedido-etapa">
                  @if (p.iconeEtapa) {
                    <mat-icon class="material-symbols-outlined" [style.color]="p.corEtapa">{{ p.iconeEtapa }}</mat-icon>
                  }
                  {{ p.nomeEtapa }}
                </span>
              </span>
              <span class="ced-nf-pedido-fornecedor ced-ellipsis" [attr.title]="p.nomeFornecedor">{{ p.nomeFornecedor }}</span>
              <span class="ced-nf-pedido-rodape">
                <span class="ced-nf-pedido-valor">{{ p.valorLabel }}</span>
                @if (p.qtdItensNota !== undefined) {
                  <span>{{ p.qtdItensNota }} {{ p.qtdItensNota === 1 ? 'item' : 'itens' }} da NF</span>
                }
              </span>
            </button>
          }
        </div>
      }

      <!-- Title + meta -->
      @if (tituloEditando) {
        <mat-form-field appearance="outline" class="ced-title-field w-100" subscriptSizing="dynamic">
          <input matInput #tituloInput [(ngModel)]="tituloDraft" maxlength="255"
            placeholder="Adicionar título"
            (keydown.enter)="salvarTitulo()"
            (keydown.escape)="cancelarTitulo()"
            (blur)="salvarTitulo()" />
        </mat-form-field>
      } @else if (isSomenteLeitura) {
        <h2 class="ced-title" [class.ced-title--vazio]="!card.title">{{ card.title || '—' }}</h2>
      } @else {
        <h2 class="ced-title ced-title--editavel" [class.ced-title--vazio]="!card.title"
          (click)="iniciarEdicaoTitulo()" matTooltip="Clique para editar o título">
          {{ card.title || 'Adicionar título' }}
        </h2>
      }
      <div class="ced-card-meta">Criado em {{ criadoEm }}</div>

      <!-- Shortcut chips -->
      <div class="ced-chips">
        @if (panel) {
          <button type="button" class="ced-chip" (click)="panel = null">
            <mat-icon class="material-symbols-outlined">arrow_back</mat-icon> Voltar
          </button>
        }
        <button type="button" class="ced-chip" [class.ced-chip--active]="panel === 'anexos'" (click)="togglePanel('anexos')">
          <mat-icon class="material-symbols-outlined">attach_file</mat-icon> Anexos
          <span class="ced-chip-badge">{{ attachments.length }}</span>
        </button>
        <button type="button" class="ced-chip" [class.ced-chip--active]="panel === 'comentarios'" (click)="togglePanel('comentarios')">
          <mat-icon class="material-symbols-outlined">chat</mat-icon> Comentários
          <span class="ced-chip-badge">{{ comments.length }}</span>
        </button>
      </div>

      <!-- Responsável -->
      @if (!panel) {
        <div class="ced-resp">
          <app-select-pesquisavel
            [control]="responsavelControl"
            [offlineList]="peopleList"
            [preloadedOptions]="peopleList"
            [idField]="'idUsuario'"
            [nameField]="'name'"
            [avatarTextField]="'key'"
            [avatarColorField]="'color'"
            [label]="'Responsável'"
            subscriptSizing="dynamic"
            (selectionChange)="onResponsavelChange($event)">
          </app-select-pesquisavel>
        </div>
      }

      @if (panel === 'anexos') {
        <!-- ===== ANEXOS PANEL (componente filho) ===== -->
        <app-ced-anexos
          [idCompra]="card.idCompra"
          [attachments]="attachments"
          [usersById]="data.usersById"
          [currentPerson]="currentPerson"
          [isSomenteLeitura]="isSomenteLeitura"
          (attachmentsChange)="attachments = $event">
        </app-ced-anexos>
      } @else if (panel === 'comentarios') {
        <!-- ===== COMENTÁRIOS PANEL (componente filho) ===== -->
        <app-ced-comentarios
          [idCompra]="card.idCompra"
          [comments]="comments"
          [peopleList]="peopleList"
          [currentPerson]="currentPerson"
          (commentsChange)="comments = $event">
        </app-ced-comentarios>
      } @else {

      <!-- Fornecedor definido — só de Pedido de Compra em diante -->
      @if (mostrarFornecedor) {
        <div class="section-title">
          <mat-icon>storefront</mat-icon>
          <span>Fornecedor</span>
        </div>
        <div class="ced-fornecedor">
          <span class="ced-fornecedor-ico">
            <mat-icon class="material-symbols-outlined">storefront</mat-icon>
          </span>
          <div class="ced-fornecedor-info">
            <div class="ced-fornecedor-nome ced-ellipsis">{{ nomeFornecedor || 'Fornecedor #' + idFornecedor }}</div>
            <div class="ced-fornecedor-sub">Fornecedor do pedido</div>
          </div>
        </div>
      }

      <!-- Produtos (compacto) — depois de Pedido de Compra; até lá a lista fica no conteúdo da etapa -->
      @if (mostrarProdutosResumo && products.length) {
        <div class="section-title">
          <mat-icon>inventory_2</mat-icon>
          <span>Produtos</span>
          <span class="status-badge badge-cinza">{{ products.length }}</span>
        </div>
        @for (p of products; track $index) {
          <div class="ced-prod-compact">
            <span class="ced-prod-compact-ico">
              <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
            </span>
            <div class="ced-prod-compact-info">
              <div class="ced-product-name ced-ellipsis">{{ p.name }}</div>
              @if (p.sku) {
                <div class="ced-product-sku">Cód. {{ p.sku }}</div>
              }
            </div>
            @if (!ocultarQuantidades) {
              <div class="ced-prod-compact-qty">{{ p.qty }} <small>{{ p.unit }}</small></div>
            }
          </div>
        }
      }

      <!-- Detalhes da solicitação -->
      <div class="section-title">
        <mat-icon>description</mat-icon>
        <span>Detalhes da solicitação</span>
      </div>

      <div class="ced-field-grid">
        <div class="ced-field">
          <mat-form-field appearance="outline" class="ced-form-field">
            <mat-label>Prioridade</mat-label>
            <mat-select [(ngModel)]="card.prio" (ngModelChange)="isDirty = true" [disabled]="isSomenteLeitura">
              <mat-option value="alta">Alta</mat-option>
              <mat-option value="media">Média</mat-option>
              <mat-option value="baixa">Baixa</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="ced-field">
          <mat-form-field appearance="outline" class="ced-form-field" floatLabel="always">
            <mat-label>Entrega desejada</mat-label>
            <input matInput [matDatepicker]="pickerEntrega" [(ngModel)]="dataEntrega" (ngModelChange)="isDirty = true" (input)="onCampoDateInput($event)" placeholder="DD/MM/AAAA" [disabled]="isSomenteLeitura">
            <mat-datepicker-toggle matIconSuffix [for]="pickerEntrega" [disabled]="isSomenteLeitura"></mat-datepicker-toggle>
            <mat-datepicker #pickerEntrega></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="ced-field ced-field--full">
          <mat-form-field appearance="outline" class="ced-form-field">
            <mat-label>Setor</mat-label>
            <input matInput [(ngModel)]="setor" (ngModelChange)="isDirty = true" placeholder="Ex.: TI, Administrativo…" [disabled]="isSomenteLeitura">
          </mat-form-field>
        </div>
        <!-- Pedido sem NF-e: só nas etapas de onde o card vai direto para Finalizado -->
        @if (isEtapaSemNotaFiscal) {
          <div class="ced-field ced-field--full">
            <mat-checkbox [(ngModel)]="isSemNotaFiscal" (ngModelChange)="isDirty = true" [disabled]="isSomenteLeitura">
              Pedido sem nota fiscal
            </mat-checkbox>
            @if (isSemNotaFiscal) {
              <div class="ced-sem-nf-nota">A compra será finalizada sem passar por Faturado/Conferência; o lançamento usará o pedido.</div>
            }
          </div>
          @if (isSemNotaFiscal) {
            <div class="ced-field ced-field--full">
              <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="!motivoSemNotaFiscal.trim()">
                <mat-label>Motivo *</mat-label>
                <input matInput [(ngModel)]="motivoSemNotaFiscal" (ngModelChange)="isDirty = true"
                  placeholder="Por que a compra não terá nota fiscal" [disabled]="isSomenteLeitura">
              </mat-form-field>
            </div>
          }
        }
      </div>

      @if (solicitanteNome) {
        <div class="ced-solicitante-row">
          <mat-icon class="material-symbols-outlined ced-sol-ico">person</mat-icon>
          <div>
            <div class="ced-label">Solicitante</div>
            <div class="ced-sol-nome">{{ solicitanteNome }}</div>
          </div>
        </div>
      }

      <!-- ===== SPLIT DE PEDIDO (componente filho; só aparece quando a compra é pai ou filha de split) ===== -->
      @if (card.idCompra) {
        <app-ced-split
          [idCompra]="card.idCompra"
          [codigo]="card.id"
          [nomeEtapaAtual]="stage.name"
          [somenteLeitura]="isSomenteLeitura"
          (revertido)="onSplitRevertido()">
        </app-ced-split>
      }

      <!-- ===== HISTÓRICO — timeline (componente filho) ===== -->
      <app-ced-historico
        #historicoTimeline
        modo="timeline"
        [history]="history"
        [carregando]="isCarregandoHistorico"
        [permiteAnotacao]="podeAnotar"
        [registrandoAnotacao]="isRegistrandoAnotacao"
        (detalhar)="openHistoryDetail($event)"
        (registrarAnotacao)="registrarAnotacao($event)">
      </app-ced-historico>
      }

    </div>

    <!-- ======= CENTER COLUMN ======= -->
    <div class="ced-col-center">

      @if (isArquivada) {
        <div class="ced-instruction ced-instruction--arquivada">
          <mat-icon class="material-symbols-outlined ced-instruction-icon">inventory_2</mat-icon>
          <div>
            <div class="ced-instruction-title">Cotação arquivada</div>
            <div class="ced-instruction-text">Esta cotação já gerou os pedidos e fica como registro de origem deles. Somente leitura.</div>
          </div>
        </div>
      } @else {
        <div class="ced-instruction" [style.border-left-color]="stage.color" [style.background]="stage.tint">
          <mat-icon class="material-symbols-outlined ced-instruction-icon" [style.color]="stage.color">lightbulb</mat-icon>
          <div>
            <div class="ced-instruction-title">O que fazer nesta etapa</div>
            <div class="ced-instruction-text">{{ meta.instruction }}</div>
          </div>
        </div>
      }

      <!-- Aprovação revogada (Faturado, Conferência, Divergência): o total mudou de faixa de alçada no ajuste do vínculo. -->
      @if (aprovacaoRevogadaPendente) {
        <div class="ced-aprovacao-revogada">
          <app-alert-card type="warning">
            A aprovação desta compra foi revogada porque o total mudou de faixa de alçada. Aprove novamente para finalizar.
          </app-alert-card>
          <app-ced-stage-aprovacao
            [idCompra]="card.idCompra"
            [usersById]="data.usersById"
            [allStages]="allStages"
            [pedido]="pedidoState"
            [backMoves]="backMoves"
            [justificativaCotacao]="cotJustificativa"
            (enviarPedido)="onEnviarPedido($event)"
            (rejeitado)="onAprovacaoRejeitada($event)"
            (aprovacaoRegistrada)="onReaprovacaoRegistrada($event)">
          </app-ced-stage-aprovacao>
        </div>
      }

      <!-- Stage-specific content -->
      @switch (card.stage) {

        <!-- SOLICITAÇÃO -->
        @case ('solicitacao') {
          <app-ced-stage-solicitacao
            [idCompra]="card.idCompra"
            [products]="products"
            [justificativa]="justificativa"
            [justificativaObrigatoria]="justificativaObrigatoria"
            (productsChange)="products = $event"
            (justificativaChange)="justificativa = $event"
            (dirty)="isDirty = true">
          </app-ced-stage-solicitacao>
        }

        <!-- COTAÇÃO -->
        @case ('cotacao') {
          <app-ced-stage-cotacao
            [card]="card"
            [products]="products"
            [criterioInicial]="cotCriterioIndex"
            [justificativa]="cotJustificativa"
            [somenteLeitura]="isSomenteLeitura"
            (productsChange)="products = $event"
            (dirty)="isDirty = true"
            (savingChange)="saving = $event"
            (criterioChange)="cotCriterioIndex = $event"
            (justificativaChange)="cotJustificativa = $event">
          </app-ced-stage-cotacao>
        }

        <!-- PEDIDO -->
        <!-- allStages (só etapas ativas) decide se o botão de envio fica aqui ou na Aprovação. -->
        @case ('pedido') {
          <app-ced-stage-pedido
            [state]="pedidoState"
            [allStages]="allStages"
            [nomeFornecedor]="nomeFornecedor"
            (dirty)="isDirty = true"
            (enviarPedido)="onEnviarPedido($event)"
            (fornecedorChange)="onPedidoFornecedorChange($event)"
            (produtoAdicionado)="products = [...products, $event]"
            (produtoRemovido)="onPedidoProdutoRemovido($event)">
          </app-ced-stage-pedido>
        }

        <!-- APROVAÇÃO -->
        <!-- pedidoState entra somente-leitura; o envio usa o mesmo handler do Pedido. -->
        @case ('aprovacao') {
          <app-ced-stage-aprovacao
            [idCompra]="card.idCompra"
            [usersById]="data.usersById"
            [allStages]="allStages"
            [pedido]="pedidoState"
            [backMoves]="backMoves"
            [justificativaCotacao]="cotJustificativa"
            (enviarPedido)="onEnviarPedido($event)"
            (rejeitado)="onAprovacaoRejeitada($event)"
            (aprovacaoRegistrada)="onAprovacaoRegistrada($event)">
          </app-ced-stage-aprovacao>
        }

        <!-- FATURADO -->
        @case ('faturado') {
          <app-ced-stage-nota [card]="card" [detalhe]="data.detalhe" [somenteLeitura]="isSomenteLeitura" (atualizado)="onNotaAtualizada()" (contextosCarregados)="onContextosNotaCarregados($event)"></app-ced-stage-nota>
        }

        <!-- CONFERÊNCIA -->
        @case ('conferencia') {
          <app-ced-stage-nota [card]="card" [detalhe]="data.detalhe" [somenteLeitura]="isSomenteLeitura" [ocultarQuantidades]="ocultarQuantidades" (atualizado)="onNotaAtualizada()" (contextosCarregados)="onContextosNotaCarregados($event)"></app-ced-stage-nota>
          <app-ced-stage-conferencia [card]="card" [idNFeEntrada]="notaModoNf?.idNFeEntrada ?? null" [contexto]="contextoNotaModoNf" [somenteLeitura]="isSomenteLeitura"
            (alterado)="conferenciaAlterada = true" (cegaPendente)="conferenciaCegaPendente = $event"
            (conferenciaConcluida)="onConferenciaConcluida($event)"></app-ced-stage-conferencia>
        }

        <!-- DIVERGÊNCIA (vínculo com "Marcar divergência" ou movimento manual a partir da Conferência) -->
        @case ('divergencia') {
          <app-ced-stage-nota [card]="card" [detalhe]="data.detalhe" [somenteLeitura]="isSomenteLeitura" (atualizado)="onNotaAtualizada()" (contextosCarregados)="onContextosNotaCarregados($event)"></app-ced-stage-nota>
          <app-ced-stage-divergencia [card]="card" [ocorrencias]="ocorrencias" [usersById]="data.usersById" [somenteLeitura]="isSomenteLeitura"
            [transitions]="transitions" (desfecho)="onDesfechoDivergencia($event)"></app-ced-stage-divergencia>
        }

        <!-- CANCELADO -->
        @case ('cancelado') {
          <app-ced-stage-cancelado
            [card]="card"
            [detalhe]="data.detalhe"
            [ocorrencias]="ocorrencias"
            [usersById]="data.usersById"
            [allStages]="allStages">
          </app-ced-stage-cancelado>
        }

        <!-- FINALIZADO -->
        @case ('finalizado') {
          <app-ced-stage-finalizado
            [card]="card"
            [detalhe]="data.detalhe"
            [usersById]="data.usersById"
            [notas]="notasPedido"
            [observacao]="finalizadoObservacao"
            (observacaoChange)="finalizadoObservacao = $event; isDirty = true"
            (alterado)="onLancamentoAlterado()"
            (carregandoChange)="carregandoEtapa.set($event)">
          </app-ced-stage-finalizado>
        }

        <!-- DEFAULT / OTHER -->
        @default {
          <div class="ced-field">
            <mat-form-field appearance="outline" class="ced-form-field">
              <mat-label>Observações</mat-label>
              <textarea matInput rows="4" [disabled]="isSomenteLeitura" placeholder="Observações sobre este card…"></textarea>
            </mat-form-field>
          </div>
        }

      }

      @if (camposEtapa.length) {
        <div class="section-title">
          <mat-icon>dynamic_form</mat-icon>
          <span>Campos da etapa</span>
          <span class="status-badge badge-cinza">{{ camposEtapa.length }}</span>
        </div>

        <div class="ced-field-grid">
          @for (campo of camposEtapa; track campo.idCampoDefinicao) {
            <div class="ced-field" [class.ced-field--full]="campo.idTipoCampo === 1">
              @switch (campo.idTipoCampo) {
                @case (2) {
                  <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)">
                    <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                    <input matInput [currencyMask]="campoNumeroMask" [(ngModel)]="campo.valorNumero" (ngModelChange)="onCampoEtapaChange()" [disabled]="isSomenteLeitura">
                  </mat-form-field>
                }
                @case (3) {
                  <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)">
                    <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                    <input matInput [currencyMask]="campoMoedaMask" [(ngModel)]="campo.valorNumero" (ngModelChange)="onCampoEtapaChange()" [disabled]="isSomenteLeitura">
                  </mat-form-field>
                }
                @case (4) {
                  <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)" floatLabel="always">
                    <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                    <input matInput [matDatepicker]="campoDatePicker" [(ngModel)]="campo.valorData" (ngModelChange)="onCampoEtapaChange()" (input)="onCampoDateInput($event)" placeholder="DD/MM/AAAA" [disabled]="isSomenteLeitura">
                    <mat-datepicker-toggle matIconSuffix [for]="campoDatePicker" [disabled]="isSomenteLeitura"></mat-datepicker-toggle>
                    <mat-datepicker #campoDatePicker></mat-datepicker>
                  </mat-form-field>
                }
                @case (5) {
                  @if (campo.opcoes.length) {
                    <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)">
                      <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                      <mat-select [(ngModel)]="campo.idCampoDefinicaoOpcao" (ngModelChange)="onCampoEtapaChange()" [disabled]="isSomenteLeitura">
                        @for (opcao of campo.opcoes; track opcao.idCampoDefinicaoOpcao) {
                          <mat-option [value]="opcao.idCampoDefinicaoOpcao">{{ opcao.descricao }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  } @else {
                    <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)">
                      <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                      <input matInput [(ngModel)]="campo.valor" (ngModelChange)="onCampoEtapaChange()" [disabled]="isSomenteLeitura">
                    </mat-form-field>
                  }
                }
                @case (6) {
                  @if (campo.opcoes.length) {
                    <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)">
                      <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                      <mat-select multiple [(ngModel)]="campo.valorMultiselect" (ngModelChange)="onCampoEtapaChange()" [disabled]="isSomenteLeitura">
                        @for (opcao of campo.opcoes; track opcao.idCampoDefinicaoOpcao) {
                          <mat-option [value]="opcao.idCampoDefinicaoOpcao">{{ opcao.descricao }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  } @else {
                    <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)" floatLabel="always">
                      <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                      <input matInput [(ngModel)]="campo.valor" (ngModelChange)="onCampoEtapaChange()" placeholder="Separe os valores por vírgula">
                    </mat-form-field>
                  }
                }
                @case (7) {
                  <app-select-pesquisavel
                    [control]="vinculoControl(campo)"
                    [apiUrl]="vinculoApiUrl(campo)"
                    [label]="campo.nome + (campo.isObrigatorio ? ' *' : '')"
                    idField="id"
                    nameField="descricao"
                    [isOptional]="!campo.isObrigatorio"
                    [preloadedOptions]="vinculoPreload(campo)"
                    (selectionChange)="onVinculoChange(campo, $event)">
                  </app-select-pesquisavel>
                }
                @default {
                  <mat-form-field appearance="outline" class="ced-form-field" [class.ced-form-field--invalid]="isCampoObrigatorioInvalido(campo)">
                    <mat-label>{{ campo.nome }}{{ campo.isObrigatorio ? ' *' : '' }}</mat-label>
                    <input matInput [(ngModel)]="campo.valor" (ngModelChange)="onCampoEtapaChange()" [disabled]="isSomenteLeitura">
                  </mat-form-field>
                }
              }
            </div>
          }
        </div>
      }

      <!-- Modo NF: itens da nota inteira agrupados por pedido -->
      @if (notaModoNf; as nota) {
        <app-ced-nota-itens
          [idNFeEntrada]="nota.idNFeEntrada"
          [pedidos]="nota.pedidos"
          [idCompraAtual]="card.idCompra ?? null"
          [detalheAtual]="data.detalhe ?? null"
          [ocultarQuantidades]="ocultarQuantidades"
          [contexto]="contextoNotaModoNf"
          (carregado)="onNotaCarregada($event)">
        </app-ced-nota-itens>
      }
    </div>

    <!-- ======= RIGHT COLUMN — detalhe da ocorrência (componente filho) ======= -->
    <app-ced-historico
      modo="detalhe"
      [selectedItem]="selectedHistoryItem"
      (fechar)="closeHistoryDetail()"
      (abrirCompra)="abrirCompraDoHistorico($event)">
    </app-ced-historico>

  </div>

  <!-- ======= FLOATING MOVE-CARD BUTTON ======= -->
  @if (!isArquivada) {
  <div class="ced-move-fab-wrap">
    @if (moveOpen) {
      <div class="ced-move-backdrop" (click)="moveOpen = false"></div>
      <div class="ced-move-panel">
        <div class="ced-move-panel-head">
          <span>Mover card</span>
          <button type="button" class="ced-move-close" (click)="moveOpen = false" matTooltip="Fechar">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
          </button>
        </div>
        <div class="ced-move-panel-body">

          <!-- Forward moves -->
          @for (mv of forwardMoves; track mv.label) {
            <button type="button"
              class="ced-mv-btn"
              [class.ced-mv-btn--skip]="mv.kind === 'skip'"
              [class.ced-mv-btn--danger]="mv.kind === 'danger'"
              [class.ced-mv-btn--alt]="mv.kind === 'alt'"
              (click)="moveTo(mv.to)">
              <span class="ced-mv-ico">
                <mat-icon class="material-symbols-outlined">{{ mv.icon || stageByKey(mv.to)?.icon || 'check' }}</mat-icon>
              </span>
              <span class="ced-mv-text">
                <!-- Pedido sem NF-e: "Finalizar sem nota fiscal", sem o prefixo "Pular para". -->
                @if (mv.to === 'finalizado' && isFinalizacaoSemNf) {
                  <span class="ced-mv-name">{{ mv.label }}</span>
                } @else {
                  <span class="ced-mv-kind">{{ moveKindLabel(mv.kind) }}</span>
                  <span class="ced-mv-name">{{ stageByKey(mv.to)?.name || mv.label }}</span>
                }
              </span>
              <mat-icon class="material-symbols-outlined ced-mv-arrow">arrow_forward</mat-icon>
            </button>
          }

          <!-- Back moves -->
          @if (backMoves.length) {
            <div class="ced-mv-section">Retornar para</div>
            @for (b of backMoves; track b) {
              <!-- Pedido enviado não volta para antes do Pedido (CA-03): desabilitado com o motivo no tooltip. -->
              <span class="ced-mv-back-wrap" [matTooltip]="motivoRetornoBloqueado(b)" [matTooltipDisabled]="!motivoRetornoBloqueado(b)">
                <button type="button" class="ced-mv-back" [disabled]="!!motivoRetornoBloqueado(b)" (click)="moveTo(b)">
                  <mat-icon class="material-symbols-outlined ced-mv-back-arrow">arrow_back</mat-icon>
                  <span class="ced-mv-back-name">{{ stageByKey(b)?.name }}</span>
                  <span class="ced-mv-back-ico" [style.background]="stageByKey(b)?.tint" [style.color]="stageByKey(b)?.color">
                    <mat-icon class="material-symbols-outlined">{{ stageByKey(b)?.icon }}</mat-icon>
                  </span>
                </button>
              </span>
            }
          }

          <!-- Terminal / cancel (só com a movimentação para Cancelado configurada na etapa atual) -->
          @if (isTerminalMove) {
            <div class="ced-mv-terminal" [style.background]="stage.tint" [style.border-color]="stage.color + '33'">
              <div class="ced-mv-terminal-head" [style.color]="stage.color">
                <mat-icon class="material-symbols-outlined">{{ card.stage === 'cancelado' ? 'block' : 'flag' }}</mat-icon>
                Estado final
              </div>
              <div class="ced-mv-terminal-text">
                {{ card.stage === 'cancelado' ? 'Card cancelado é irreversível. Não há destinos de saída.' : 'Este card está finalizado. Não há destinos de saída.' }}
              </div>
            </div>
          } @else if (podeCancelar) {
            <div class="ced-mv-divider"></div>
            <span [matTooltip]="semPermissaoCancelarCompra" [matTooltipDisabled]="data.podeCancelarCompra !== false">
              <button type="button" class="ced-mv-cancel btn-spinner" [class.btn-loading]="cancelando"
                [disabled]="cancelando || data.podeCancelarCompra === false"
                [attr.aria-label]="cancelando ? 'Cancelando compra' : null" (click)="cancelCard()">
                <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                <span>Cancelar compra</span>
                @if (cancelando) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
            </span>
            <div class="ced-mv-cancel-note">Cancelar exige justificativa registrada no histórico.</div>
          }
        </div>
      </div>
    }

    <button type="button" class="ced-move-fab" [class.ced-move-fab--open]="moveOpen"
      (click)="moveOpen = !moveOpen"
      [matTooltip]="moveOpen ? 'Fechar movimentações' : 'Mover card para outra etapa'">
      <mat-icon class="material-symbols-outlined">{{ moveOpen ? 'close' : 'swap_horiz' }}</mat-icon>
    </button>
  </div>
  }
</div>
